import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { SizeCodesListFilterKeys } from '../../model/types';
import { SizeCodeType } from 'entities/SizeCode';

interface SizeCodeTypeSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const SizeCodeTypeSelect: FC<SizeCodeTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const sizeCodeTypeOptions = Object.values(SizeCodeType).map((type) => ({
    label: type,
    value: type,
  }));

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(SizeCodesListFilterKeys.sizeGroup);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Size code type')}
      placeholder={t('All')}
      bordered
      allowClear
      options={sizeCodeTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
